<template>
  <div :class="$options.name">
    <v-card>
      <v-toolbar color="blue darken-3" dark flat>
        <v-btn
          v-permission="['category-create']"
          color="primary"
          class="elevation-0"
          @click="$dialog.show('new-category-dialog')"
        >
          Создать категорию
        </v-btn>
        <div class="flex-grow-1" />
        <!-- <v-text-field
          label="Поиск по категориям"
          prepend-inner-icon="search"
          flat
          clearable
          single-line
          hide-details
        />-->
      </v-toolbar>
      <v-tree-data-table
        :items="list"
        :headers="headers"
        :loading="isLoading"
        :pagination="pagination"
        :edit="{ dialog: 'category-edit-dialog', permission: ['category-edit'] }"
        :remove="{ dialog: 'remove-category-confirmation', permission: ['category-delete'] }"
        @on-change-page="onChangePage($event)"
      />
    </v-card>

    <new-category-dialog :icon-list="iconList" @submitted="onCategorySubmitted" />
    <category-edit-dialog :icon-list="iconList" @submitted="onCategorySubmitted" />
    <remove-category-confirmation @confirmed="onRemoveConfirmed" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VTreeDataTable from '@/components/common/tree-data-table';
import NewCategoryDialog from './components/NewCategoryDialog.vue';
import CategoryEditDialog from './components/CategoryEditDialog.vue';
import RemoveCategoryConfirmation from './components/RemoveCategoryConfirmation.vue';

export default {
  name: 'references-categories-list-view',

  asyncData({ store }) {
    const actions = [
      store.dispatch('categories/getList'),
      store.dispatch('icons/getFullList'),
    ];

    return Promise.all(actions);
  },

  components: {
    NewCategoryDialog,
    CategoryEditDialog,
    RemoveCategoryConfirmation,
    VTreeDataTable,
  },

  data: () => ({
    headers: [
      {
        value: 'icon',
        sortable: false,
        width: '1%',
        align: 'center',
      },
      { value: 'name', text: 'Название категории', sortable: false },
      { value: 'actions', sortable: false, width: '20%' },
    ],
    isLoading: false,
  }),

  computed: {
    ...mapState('categories', ['list', 'pagination']),
    ...mapState('icons', {
      iconList: 'fullList',
    }),
  },

  methods: {
    ...mapActions('categories', ['getList', 'remove', 'getNextPage']),
    ...mapActions(['showNotify']),

    async onCategorySubmitted() {
      this.isLoading = true;
      await this.getList();
      this.isLoading = false;
    },

    async onRemoveConfirmed(itemId) {
      this.isLoading = true;

      try {
        await this.remove(itemId);
        await this.getList();
        this.showNotify({ message: 'Категория успешно удалена' });
      } catch (e) {
        //
      } finally {
        this.isLoading = false;
      }
    },

    async onChangePage(page) {
      this.isLoading = true;
      await this.getNextPage({ page });
      this.isLoading = false;
    },
  },
};
</script>
